import ProjectCore, { IProject } from "./ProjectCore";

export interface IProjectTimeAndMaterials extends IProject {}

export default class ProjectTimeAndMaterials extends ProjectCore {
  constructor(dto: IProjectTimeAndMaterials) {
    super(dto);
  }
}
